<template>
    <div class="section4">
        <div class="wap_header">
            <img class="tit" :src="require(`../../assets/${language}/4-1/tit.png`)" alt="">
        </div>
        <transition name="fade">
            <div class="s4_box" v-if="!showList">
                <div class="sb_header">
                    <img class="tit" :src="require(`../../assets/${language}/4-1/4_1tit.png`)" alt="">
                    <div class="more" @click="more">MORE+</div>
                </div>
                <ul class="news-list">
                    <li :class="['news-item', { 'active': firstin }]" v-for="(item, i) in newsList" :key="i"
                        :title="item.title" @click="getDetail(item.id)">
                        <img :src="item.image" alt="">
                        <div class="tit">
                            <p>
                                <span v-if="item.type == 1">【{{ i18n('notice') }}】</span>
                                <span v-else-if="item.type == 2">【{{ i18n('news') }}】</span>
                                <span v-else-if="item.type == 4">【{{ i18n('guides') }}】</span>
                                {{ item.title }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </transition>
        <transition name="fade">
            <div class="s4_box2" v-if="showList">
                <div class="news_area" @wheel.stop @touchstart.stop="handleTouchStart"
                 @touchmove.stop="handleTouchMove"
                 @touchend.stop="handleTouchEnd">
                    <img class="tit" :src="require(`../../assets/${language}/4-2/4_2tit.png`)" alt="">
                    <ul class="tabs">
                        <li :class="['btn',{'active': tag_id == item.id}]" v-for="(item,i) in tags" :key="item.id" @click="getNews(item.id)" :style="{'background-image': tag_id == item.id ? `url(${require(`../../assets/${language}/4-2/tab${i + 1}_active.png`)})` : `url(${require(`../../assets/${language}/4-2/tab${i + 1}.png`)})`}">
                            <span>{{ item.type }}</span>
                        </li>
                    </ul>
                    <div class="btn back" @click="showList = !showList;getNews()"></div>
                    <ul class="newsList" ref="newsList">
                        <li v-for="(item,i) in newsList" :key="i" @click="getDetail(item.id)">
                            <div class="left">
                                <img :src="item.image" alt="">
                            </div>
                            <div class="right">
                                <div class="tit_cont">
                                    <p class="r-tit">
                                        <span v-if="item.type == 1">【{{ i18n('notice') }}】</span>

                                        <span v-else-if="item.type == 2">【{{ i18n('news') }}】</span>
                                        <span v-else-if="item.type == 4">【{{ i18n('guides') }}】</span>
                                        {{ item.title }}
                                    </p>
                                    <p class="cont"></p>
                                </div>
                                <div class="time">{{ item.create_time.slice(0,11) }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import i18n from '../i18n'

export default {
    props: ['language','i18n'],

    data() {
        return {
            firstin: false,
            newsList: [],
            showList: false,//控制显示新闻列表
            tag_id: 1
        }
    },
    computed: {
        tags() {
            return [
                {id: 1,type: this.i18n('notice')},
                {id: 2,type: this.i18n('news')},
                {id: 4,type: this.i18n('guides')}
            ]
        }
    },
    methods: {
        onFirstVisit() {
            this.firstin = true
            this.getNews()
        },
        getNews(type) {
            this.newsList = []
            if(type) {
                this.tag_id = type;
            }
            this.$http.get('MlbbNews/getNewsList', { type }).then(res => {
                if (res.code == 0) {
                    if(type) {
                        this.newsList = res.data.data
                    }else {
                        this.newsList = res.data.data.slice(0, 5)
                    }
                }
            })
        },
        getDetail(id) {
            this.$http.get('MlbbNews/getNewsDetail',{id}).then(res => {
                if(res.code == 0) {
                    this.$emit('openNewsDetail',{title: res.data.title,create_time: res.data.create_time,content: res.data.content})
                }
            })
        },
        more() {
            this.newsList = []
            this.showList = !this.showList;
            this.getNews(this.tag_id);
        },
        refreshData() {
            if(this.showList) {
                this.getNews(this.tag_id);
            }else {
                this.getNews();
            }
        },
        handleTouchStart(e) {
            // 记录初始触摸位置
            this.touchStartY = e.touches[0].clientY;
            this.scrollTop = this.$refs.newsList.scrollTop;
        },
        
        handleTouchMove(e) {
            // 阻止默认行为和事件冒泡
            e.preventDefault();
            e.stopPropagation();
            
            const currentY = e.touches[0].clientY;
            const deltaY = this.touchStartY - currentY;
            
            // 手动控制滚动
            this.$refs.newsList.scrollTop = this.scrollTop + deltaY;
        },
        
        handleTouchEnd(e) {
            // 触摸结束时的处理
            e.stopPropagation();
        }
    },
    watch: {
        language: {
            handler(newLang, oldLang) {
                if (oldLang && newLang !== oldLang) {
                    this.refreshData();
                }
            },
            immediate: true
        }
    }
}
</script>
<style lang="less" scoped>

.section4 {
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/4-1/4_1bg.png) center center / cover no-repeat;
    position: relative;

    .s4_box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 17.36rem;
        height: 6.34rem;

        .sb_header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: .2rem;

            .tit {
                width: auto;
                height: .38rem;
            }

            .more {
                width: 1.33rem;
                height: .5rem;
                line-height: .5rem;
                color: #B04B30;
                text-align: center;
                background: url(../../assets/zh/4-1/4_1more.png) 0 center / 100% 100% no-repeat;
                font-size: .2rem;
                font-weight: 700;
                cursor: pointer;
                &:active {
                    transform: scale(0.98);
                }
            }
        }

        .news-list {
            width: 100%;
            .news-item {
                width: 3.77rem;
                float: left;
                margin-left: .46rem;
                cursor: pointer;
                opacity: 0;
                transform: translateY(.8rem);

                &.active {
                    animation: newsmove 1s ease forwards;
                }

                img {
                    width: 100%;
                    height: 2.55rem;
                    background-color: #000;
                }

                .tit {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    color: #f9e7cd;
                    font-size: .24rem;
                    display: flex;
                    overflow: hidden;
                    // i {
                    //     width: .15rem;
                    //     height: .15rem;
                    //     margin-right: .06rem;
                    //     background: url(../../assets/zh/4-1/biao.png) 0 0 / 100% 100% no-repeat;
                    // }

                    p {
                        display: flex;
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        position: relative;
                        padding: 0.05rem 0.2rem;
                        color: #B04B30;
                        background-color: #fff;
                        font-size: .2rem;
                        line-height: 1.5;
                        border-bottom-left-radius: .18rem;
                        border-bottom-right-radius: .18rem;
                    }
                }

                &:nth-of-type(1) {
                    animation-duration: .3s;
                    width: 8.56rem;
                    margin-left: 0;
                    margin-right: .34rem;

                    img {
                        height: 5.55rem;
                    }
                    p {
                        padding: 0.075rem 0.2rem;
                        font-size: .24rem;
                        line-height: 1.7;
                    }
                }

                &:nth-of-type(2) {
                    animation-duration: .6s;
                }

                &:nth-of-type(3) {
                    animation-duration: .9s;
                }

                &:nth-of-type(4) {
                    animation-duration: 1.2s;
                }

                &:nth-of-type(5) {
                    animation-duration: 1.5s;
                }

                &:nth-of-type(2),
                &:nth-of-type(3) {
                    margin-bottom: .22rem;
                }
            }
        }
    }

    .s4_box2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
   
        .news_area {
            width: 13.2rem;
            height: 6.95rem;
            background: url(../../assets/zh/4-2/4_2bg.png) 0 0 / 100% 100% no-repeat;
            padding: .48rem .8rem .48rem 1rem;
            /* 添加touch-action属性 */
            touch-action: pan-y; /* 只允许垂直滚动 */
            position: relative;
            &::before {
                content: '';
                position: absolute;
                top: -.2rem;
                left: 50%;
                transform: translateX(-50%);
                width: 6.71rem;
                height: 1.06rem;
                background: url(../../assets/zh/4-2/tit_bg.png) 0 0 / 100% 100% no-repeat;
                pointer-events: none; 
            }
            .tit {
                width: auto;
                height: .81rem;
                position: absolute;
                top: -.4rem;
                left: 50%;
                transform: translateX(-50%);
                z-index: 2;
            }
            .back {
                position: absolute;
                right: -.4rem;
                top: -.25rem;
                width: 1.21rem;
                height: 1.21rem;
                background: url(../../assets/zh/4-2/back.png) 0 0 / 100% 100% no-repeat;
                cursor: pointer;
            }
            .tabs {
                position: absolute;
                left: 0.1rem;
                top: 1rem;
                width: 2.18rem;
                .btn {
                    width: 2.18rem;
                    height: .82rem;
                    background-size: 100%;
                    background-position: 0 0;
                    background-repeat: no-repeat;
                    background-color: unset;
                    span {
                        display: none;
                    }
                }
            }
            ul.newsList {
                position: absolute;
                top: 1.16rem;
                left: 2.5rem;
                width: 9.8rem;
                height: 4.8rem;
                padding: 0.2rem 0.3rem;
                overflow-x: hidden;
                overflow-y: auto;
                touch-action: pan-y;
                -webkit-overflow-scrolling: touch;
                background: url(../../assets/zh/4-2/4_2bg_bg.png) 0 0 / 100% 100% no-repeat;
                &::-webkit-scrollbar {
                  width: .12rem;
                }
                &::-webkit-scrollbar-track {
                  width: .05rem;
                  border-top: none;
                  border-bottom: none;
                  background: url(../../assets/zh/track.png) 0.025rem 0 / .05rem 100% no-repeat;
                }
                &::-webkit-scrollbar-thumb {
                  width: .12rem;
                  background-color: #D37966;
                  border-radius: 0.2rem;
                }
            }
            li {
                display: flex;
                margin-bottom: .03rem;
                cursor: pointer;
                height: 1.45rem;
                padding: 0.1rem;
                background-color: #fef8f0;
                border-radius: 0.06rem;
                .left {
                    margin-right: .2rem;
                    height: 100%;
                    img {
                        width: auto;
                        height: 100%;
                        background-color: #000;
                    }
                }
                .right {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    padding: 0.1rem 0;
                    .tit_cont {
                        .r-tit {
                            margin-bottom: .14rem;
                            font-size: .24rem;
                            width: 100%;
                            color: #61372E;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            span {
                                color: #B04B30;
                                font-weight: 700;
                            }
                        }
                        .cont {
                            padding-left: .1rem;
                            color: #888;
                            font-size: .2rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .time {
                        padding-left: .1rem;
                        color: #61372E;
                        font-size: .16rem;
                    }
                }
            }
        }
    }
}
.wap_header {
    display: none;
}
@keyframes newsmove {
    0% {
        opacity: 0;
        transform: translateY(.8rem);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media screen and (max-width: 751px) {
    .wap_header {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7.4rem;
        height: 1.27rem;
        background: url(../../assets/wap/zh/4-1/tit_bg.png) 0 0 / 100% 100% no-repeat;
        margin: 0 auto;
        .tit {
            height: .41rem;
        }
    }
    .section4 {
        padding-top: 1.5rem;
        .s4_box {
            position: unset;
            transform: unset;
            width: 5.94rem;
            margin: 0 auto;
            .sb_header {
                width: 100%;
                justify-content: flex-end;
                .tit {
                    display: none;
                    margin: 0 auto .2rem;
                    height: .38rem;
                }
            }
            .news-list {
                .news-item {
                    width: 49%;
                    margin: 0;
                    -webkit-tap-highlight-color: transparent;
                    img {
                        height: auto;
                    }
                    &:nth-of-type(1) {
                        width: 100%;
                        margin-right: 0;
                        margin-bottom: .22rem;
                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                    &:nth-of-type(2),
                    &:nth-of-type(3) {
                        animation-duration: .6s;
                    }
                    &:nth-of-type(4),
                    &:nth-of-type(5) {
                        animation-duration: .9s;
                    }
                    &:nth-of-type(2n) {
                        margin-right: 2%;
                    }
                    .tit {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i {
                            transform: translateY(.02rem);
                        }
                        p {
                            flex: unset;
                            width: 100%;
                        }
                    }
                }
            }
        }
        .s4_box2 {
            top: 3.57rem;
            transform: translate(-50%,0);
            .tit {
                display: none;
                margin: 0 auto .4rem;
                height: .38rem;
            }
            .header {
                width: 6.16rem;
                .btn {
                    width: .9rem;
                    height: .28rem;
                    line-height: .28rem;
                    font-size: .16rem;
                }
                .right {
                    width: auto;
                }
            }
            .news_area {
                width: 7.18rem;
                height: 9.04rem;
                background: url(../../assets/wap/zh/4-2/4_2_Frames.png) 0 0 / 100% 100% no-repeat;
                padding: .4rem;
                /* 移动端更严格的触摸控制 */
                touch-action: pan-y;
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                &::before {
                    display: none;
                }
                .tabs {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    width: 5.82rem;
                    height: .57rem;
                    left: 50%;
                    transform: translateX(-50%);
                    top: -0.32rem;
                    .btn {
                        width: 1.94rem;
                        height: 100%;
                        background-image: url(../../assets/wap/zh/4-2/tab.png) !important;
                        -webkit-tap-highlight-color: transparent;
                        span {
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            color: #B04B30;
                            font-size: .24rem;
                            font-weight: 700;
                        }
                        &.active {
                            background-image: url(../../assets/wap/zh/4-2/tab_active.png) !important
                        }
                    }
                }
                .back {
                    width: .6rem;
                    height: .6rem;
                    background: unset;
                    border-radius: 50%;
                    top: 0.12rem;
                    right: 0.15rem;
                }
                ul.newsList {
                    left: 50%;
                    transform: translateX(-50%);
                    width: 5.42rem;
                    top: .95rem;
                    height: 7.2rem;
                    background: unset;
                    padding: 0;
                    li {
                        .left {
                            margin-right: .08rem;
                        }
                        .right {
                            .tit_cont  {
                                .r-tit {
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    white-space: wrap;
                                }
                            }
                            
                        }
                    }
                }
            }
        }
    }
}
</style>